import React, { useState, useEffect, useRef } from 'react';
import { useStateValue } from './StateProvider.js';
import axios from 'axios';
import configData from './Config';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import ReactToPrint from 'react-to-print';

import { getPermission } from './Utils/permissions.js';
import Title from './Title.js';
import Select from './Components/select.js';
import { loadAssets, loadReadings } from './Utils/dataloader.js';

import './Readings.css';

function Readings({ state, setState }) {
    const [{ project }, dispatch] = useStateValue();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleCloseModal = () => {
        setState(state => ({ ...state, modalopen: false, modalcontent: null, modaltype: null, modaltitle: null }));
    }

    const addReadingButton = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <AddReading />, modaltype: 'large', modaltitle: 'Add Reading' }));
    }

    const editButton = (reading) => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <EditReading reading={reading} mode='edit' />, modaltype: 'large', modaltitle: 'Edit Reading' }));
    }

    const viewButton = (reading) => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <ViewReading reading={reading} />, modaltype: 'small', modaltitle: 'View Reading' }));
    }

    const cloneButton = (reading) => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <EditReading reading={reading} mode='clone' />, modaltype: 'large', modaltitle: 'Clone Reading' }));
    }

    const removeButton = (reading) => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <RemoveReading reading={reading} />, modaltype: 'small', modaltitle: 'Remove Reading' }));
    }

    const viewReadings = (readings) => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <Readings readings={readings} />, modaltype: 'large', modaltitle: 'Readings' }));
    }

    useEffect(() => {
        loadAssets(project, state, dispatch);
        loadReadings(project, state, dispatch);
    }, []);

    useEffect(() => {
        if (project.assets.length == 0) {
            console.log('Trying to get assets');

            const data = {
                projectuserid: project.projectuserid,
                projectid: project.projectid,
                archived: project.archived,
            }

            axios.post(configData.CONTROLLERURL + configData.GETASSETS, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then((res) => {
                console.log('Get assets data received')
                if (res.data instanceof Array) {
                    dispatch({
                        type: 'ADD_ASSETS',
                        assets: res.data
                    });
                }
            }).catch(() => {
            }).finally(() => {
            });
        }
        else {
            console.log('Assets found in state')
        }
    }, []);

    function NewRow({ row, index, handleAssetChange, handleReadingChange, handleRemoveRow }) {
        return (
            <tr>
                <td>
                    <Select data={project.assets} itemid={row.assetid} setItemid={(assetId) => handleAssetChange({ target: { value: assetId } }, index)} />
                </td>

                <td>
                    <input
                        className='modal_input'
                        type="number"
                        value={row.reading}
                        onChange={(e) => handleReadingChange(e, index)}
                    />
                </td>
                <td>
                    <div className='modal_removeitembutton' onClick={() => handleRemoveRow(index)}>&minus;</div>
                </td>
            </tr>
        );
    }

    function AddReading() {
        const [selecteddate, setSelecteddate] = useState(new Date());
        const [timestamp, setTimestamp] = useState(0);

        const [name, setName] = useState('');
        const [rows, setRows] = useState([{ assetid: '', reading: 0 }]);

        const [amount, setAmount] = useState(0);

        const [result, setResult] = useState(null);
        const [loading, setLoading] = useState(false);

        useEffect(() => {
            const dateAtMidday = new Date(selecteddate);
            const unixTimestamp = Math.floor(dateAtMidday.getTime() / 1000);
            setTimestamp(unixTimestamp);
        }, [selecteddate]);

        const handleAddRow = () => {
            setRows([...rows, { assetid: '', reading: 0 }])
        };

        const handleAssetChange = (event, index) => {
            const selectedRow = event.target.value;
            const updatedRows = [...rows];
            updatedRows[index].assetid = selectedRow;
            setRows(updatedRows);
        };

        const handleReadingChange = (event, index) => {
            const selectedRow = event.target.value;
            const updatedRows = [...rows];
            updatedRows[index].reading = selectedRow;
            setRows(updatedRows);
        };

        const handleRemoveRow = (indexToRemove) => {
            if (rows.length > 1) {
                const updatedRows = rows.filter((_, index) => index !== indexToRemove);
                setRows(updatedRows);
            }
        };

        const totalAmount = rows.reduce((total, row) => total + (parseFloat(row.reading) || 0), 0);

        const addReading = () => {
            console.log('Trying to add reading');

            setResult('');

            const hasPermission = getPermission(
                project.projectuserid,
                project.users,
                state.user.userid,
                'Readings',
                'add',
                project.archived
            );
            if (hasPermission.code == 0) {
                setResult(hasPermission.data);
                return;
            }

            setLoading(true);

            const data = {
                projectuserid: project.projectuserid,
                projectid: project.projectid,
                ts: timestamp,
                name: name,
                rows: rows,
                amount: totalAmount,
            }

            axios.post(configData.CONTROLLERURL + configData.ADDREADING, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then((res) => {
                console.log('Add reading data received')
                console.log(res.data)
                if (res.data instanceof Object) {
                    if (res.data.code === 1) {
                        data.id = res.data.id;
                        dispatch({
                            type: 'ADD_READING',
                            reading: data
                        });
                        handleCloseModal();
                    }
                    else {
                        setResult(res.data.data)
                    }
                }
                else {
                    setResult('Error');
                }
            }).catch((err) => {
                setResult(err.response?.data?.message || err.message || 'Network error');
            }).finally(() => {
                setLoading(false);
            });
        }

        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Date</div>
                        </div>
                        <div className='modal_rowsection'>
                            <DatePicker
                                className='modal_datepicker'
                                selected={selecteddate}
                                onChange={(date) => setSelecteddate(date)}
                                showTimeSelect
                                dateFormat="Pp"
                            />
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Name</div>
                        </div>
                        <div className='modal_rowsection'>
                            <input
                                className='modal_input'
                                type="text"
                                placeholder="Name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>
                    </div>
                    <table className='modal_table'>
                        <thead>
                            <tr>
                                <th>Asset</th>
                                <th>Reading</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                rows.map((row, index) => (
                                    <NewRow
                                        key={'row' + index}
                                        row={row}
                                        index={index}
                                        handleAssetChange={handleAssetChange}
                                        handleReadingChange={handleReadingChange}
                                        handleRemoveRow={handleRemoveRow}
                                    />
                                ))
                            }
                        </tbody>
                        <tfoot>
                            <tr>
                                <td>Total</td>
                                <td></td>
                                <td>{totalAmount}</td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <div className='modal_button' onClick={handleAddRow}>Add row</div>
                        </div>
                        <div className='modal_buttoncontainer'>
                        </div>
                    </div>
                </div>
                <div className='modal_actions'>
                    {result && <div className='modal_result'>{result}</div>}
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={() => addReading()} disabled={loading}>{loading ? 'Loading...' : 'Save'}</button>
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={handleCloseModal}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    function EditReading({ reading, mode }) {
        const [id, setId] = useState('');

        const [selecteddate, setSelecteddate] = useState(new Date());
        const [timestamp, setTimestamp] = useState(0);

        const [name, setName] = useState('');
        const [rows, setRows] = useState([{ assetid: '', reading: 0 }]);

        const [amount, setAmount] = useState(0);

        const [result, setResult] = useState(null);
        const [loading, setLoading] = useState(false);

        useEffect(() => {
            if (reading) {
                const readingCopy = {
                    ...reading,
                    rows: Array.isArray(reading.rows) ? reading.rows.map(row => ({ ...row })) : []
                };

                setId(readingCopy.id);
                setSelecteddate(new Date(readingCopy.ts * 1000));
                setName(readingCopy.name)
                setRows(readingCopy.rows);
                setAmount(readingCopy.amount);
            }
        }, [reading]);

        useEffect(() => {
            const dateAtMidday = new Date(selecteddate);
            const unixTimestamp = Math.floor(dateAtMidday.getTime() / 1000);
            setTimestamp(unixTimestamp);
        }, [selecteddate]);

        const handleAddRow = () => {
            setRows([...rows, { assetid: '', reading: 0 }])
        };

        const handleAssetChange = (event, index) => {
            const selectedRow = event.target.value;
            const updatedRows = [...rows];
            updatedRows[index].assetid = selectedRow;
            setRows(updatedRows);
        };

        const handleReadingChange = (event, index) => {
            const selectedRow = event.target.value;
            const updatedRows = [...rows];
            updatedRows[index].reading = selectedRow;
            setRows(updatedRows);
        };

        const handleRemoveRow = (indexToRemove) => {
            if (rows.length > 1) {
                const updatedRows = rows.filter((_, index) => index !== indexToRemove);
                setRows(updatedRows);
            }
        };

        const totalAmount = rows.reduce((total, row) => total + (parseFloat(row.reading) || 0), 0);

        const addReading = () => {
            console.log('Trying to add reading');

            setResult('');

            const hasPermission = getPermission(
                project.projectuserid,
                project.users,
                state.user.userid,
                'Readings',
                'add',
                project.archived
            );
            if (hasPermission.code == 0) {
                setResult(hasPermission.data);
                return;
            }

            setLoading(true);

            const data = {
                projectuserid: project.projectuserid,
                projectid: project.projectid,
                ts: timestamp,
                name: name,
                rows: rows,
                amount: totalAmount
            }

            axios.post(configData.CONTROLLERURL + configData.ADDREADING, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then((res) => {
                console.log('Add reading data received')
                console.log(res.data)
                if (res.data instanceof Object) {
                    if (res.data.code === 1) {
                        data.id = res.data.id;
                        dispatch({
                            type: 'ADD_READING',
                            reading: data
                        });
                        handleCloseModal();
                    }
                    else {
                        setResult(res.data.data)
                    }
                }
                else {
                    setResult('Error');
                }
            }).catch((err) => {
                setResult(err.response?.data?.message || err.message || 'Network error');
            }).finally(() => {
                setLoading(false);
            });
        }

        const updateReading = () => {
            console.log('Trying to update reading');

            setResult('');

            const hasPermission = getPermission(
                project.projectuserid,
                project.users,
                state.user.userid,
                'Readings',
                'add',
                project.archived
            );
            if (hasPermission.code == 0) {
                setResult(hasPermission.data);
                return;
            }

            const areAllReadingsValid = rows.every(row => !isNaN(parseFloat(row.reading)));
            if (!areAllReadingsValid) {
                setResult('Invalid readings. Please enter valid numbers.');
                return;
            }

            setLoading(true);

            const data = {
                projectuserid: project.projectuserid,
                projectid: project.projectid,
                id: id,
                ts: timestamp,
                name: name,
                rows: rows,
                amount: totalAmount
            }

            axios.post(configData.CONTROLLERURL + configData.UPDATEREADING, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then((res) => {
                console.log('Update reading data received')
                console.log(res.data)
                if (res.data instanceof Object) {
                    if (res.data.code === 1) {
                        dispatch({
                            type: 'UPDATE_READING',
                            reading: data
                        });
                        handleCloseModal();
                    }
                    else {
                        setResult(res.data.data)
                    }
                }
                else {
                    setResult('Error');
                }
            }).catch((err) => {
                setResult(err.response?.data?.message || err.message || 'Network error');
            }).finally(() => {
                setLoading(false);
            });
        }

        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Date</div>
                        </div>
                        <div className='modal_rowsection'>
                            <DatePicker
                                className='modal_datepicker'
                                selected={selecteddate}
                                onChange={(date) => setSelecteddate(date)}
                                showTimeSelect
                                dateFormat="Pp"
                            />
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Name</div>
                        </div>
                        <div className='modal_rowsection'>
                            <input
                                className='modal_input'
                                type="text"
                                placeholder="Name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className='modal_row'>
                        <table className='modal_table'>
                            <thead>
                                <tr>
                                    <th>Asset</th>
                                    <th>Reading</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    rows.map((row, index) => (
                                        <NewRow
                                            key={'row' + index}
                                            row={row}
                                            index={index}
                                            handleAssetChange={handleAssetChange}
                                            handleReadingChange={handleReadingChange}
                                            handleRemoveRow={handleRemoveRow}
                                        />
                                    ))
                                }
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td>Total</td>
                                    <td></td>
                                    <td>{totalAmount}</td>
                                    <td></td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <div className='modal_button' onClick={handleAddRow}>Add row</div>
                        </div>
                        <div className='modal_buttoncontainer'></div>
                    </div>
                </div>
                <div className='modal_actions'>
                    {result && <div className='modal_result'>{result}</div>}
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            {mode == 'edit' && <button className="modal_button" onClick={() => updateReading()} disabled={loading}>{loading ? 'Loading...' : 'Update'}</button>}
                            {mode == 'clone' && <button className="modal_button" onClick={() => addReading()} disabled={loading}>{loading ? 'Loading...' : 'Add'}</button>}
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={() => removeButton(reading)}>Remove</button>
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={handleCloseModal}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div >
        )
    }

    function RemoveReading({ reading }) {
        const [id, setId] = useState('');

        const [result, setResult] = useState(null);
        const [loading, setLoading] = useState(false);

        useEffect(() => {
            setId(reading.id);
        }, [reading]);

        const removeReading = (id) => {
            console.log('Trying to remove reading');

            setResult('');

            const hasPermission = getPermission(
                project.projectuserid,
                project.users,
                state.user.userid,
                'Readings',
                'remove',
                project.archived
            );
            if (hasPermission.code == 0) {
                setResult(hasPermission.data);
                return;
            }

            setLoading(true);

            const data = {
                projectuserid: project.projectuserid,
                projectid: project.projectid,
                id: id
            }

            axios.post(configData.CONTROLLERURL + configData.REMOVEREADING, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then((res) => {
                console.log('Remove reading data received')
                console.log(res.data)
                if (res.data instanceof Object) {
                    if (res.data.code === 1) {
                        dispatch({
                            type: 'REMOVE_READING',
                            readingid: id
                        });
                        handleCloseModal();
                    }
                    else {
                        setResult(res.data.data)
                    }
                }
                else {
                    setResult('Error');
                }
            }).catch((err) => {
                setResult(err.response?.data?.message || err.message || 'Network error');
            }).finally(() => {
                setLoading(false);
            });
        }

        return (
            <div className='modal_body'>
                <div className='modal_actions'>
                    {result && <div className='modal_result'>{result}</div>}
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={() => removeReading(id)} disabled={loading}>{loading ? 'Loading...' : 'Remove'}</button>
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={handleCloseModal}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    function ViewReading({ reading }) {
        const [timestamp, setTimestamp] = useState(0);

        const [rows, setRows] = useState([]);

        const [amount, setAmount] = useState(0);

        const printRef = useRef();

        useEffect(() => {
            setTimestamp(reading.ts);
            setRows(reading.rows);
            setAmount(reading.amount);
        }, [reading]);

        const totalAmount = rows.reduce((total, row) => total + (parseFloat(row.reading) || 0), 0);

        return (
            <div className='modal_body'>
                <div className='modal_printable' ref={printRef}>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Project Name</div>
                        </div>
                        <div className='modal_rowsection'>{project.name}</div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Date</div>
                        </div>
                        <div className='modal_rowsection'>{moment.unix(timestamp).format('D MMMM YYYY hh:mm:ss A')}</div>
                    </div>
                    <div className='modal_row'>
                        <table className='modal_table'>
                            <thead>
                                <tr>
                                    <th>Asset</th>
                                    <th>Reading</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    rows.map((row, index) => {
                                        const assetName = project.assets.find((ass) => ass.id == row.assetid)?.name;
                                        return (
                                            <tr key={'row' + index}>
                                                <td>{assetName}</td>
                                                <td>{row.reading}</td>
                                            </tr>
                                        )
                                    }
                                    )
                                }
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td>Total</td>
                                    <td>{totalAmount}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <ReactToPrint
                                trigger={() => (<button className="modal_button">Print</button>)}
                                content={() => printRef.current}
                            />
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={() => cloneButton(reading)}>Clone</button>
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={handleCloseModal}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    function Readings({ readings }) {
        const [data, setData] = useState([]);
        const [meters, setMeters] = useState([]);

        const printRef = useRef();

        useEffect(() => {
            if (!readings.length) return;

            const timestampsMap = {};
            const assetIds = new Set();

            readings.forEach(({ ts, rows }) => {
                if (!timestampsMap[ts]) {
                    timestampsMap[ts] = { ts };
                }

                rows.forEach(({ assetid, reading }) => {
                    timestampsMap[ts][assetid] = reading || 0;
                    assetIds.add(assetid);
                });
            });

            const structuredData = Object.values(timestampsMap).sort((a, b) => a.ts - b.ts);

            setMeters([...assetIds])
            setData(structuredData);
        }, [readings]);

        return (
            <div className='modal_body'>
                <div className='modal_printable' ref={printRef}>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <table className='modal_table'>
                                <thead>
                                    <tr>
                                        <th>Asset</th>
                                        {
                                            data.map((item, index) => (
                                                <th key={'item' + index}>{moment.unix(item.ts).format('D/MMM/YYYY')}</th>
                                            ))
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        meters.map((meter) => {
                                            return (
                                                <tr key={'meter' + meter}>
                                                    <td>{project.assets.find(ass => ass.id == meter)?.name}</td>
                                                    {
                                                        data.map((item, index) => (
                                                            <td key={'meter-reading' + index}>
                                                                {item[meter] || 0}
                                                            </td>
                                                        ))
                                                    }
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td>Total</td>
                                        {
                                            data.map((item, index) => {
                                                const total = meters.reduce((sum, meter) => {
                                                    const reading = parseFloat(item[meter]) || 0;
                                                    return sum + reading;
                                                }, 0);

                                                return (
                                                    <td key={'total' + index}>
                                                        {total !== 0 ? total : 0}
                                                    </td>
                                                );
                                            })
                                        }
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <ReactToPrint
                                trigger={() => (<button className="modal_button">Print</button>)}
                                content={() => printRef.current}
                            />
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={handleCloseModal}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className='readings'>
            <Title text='Readings' />

            <div className='buttonscontainer'>
                <div className='buttonsection'>
                    <button className='button' onClick={addReadingButton}>Add Reading</button>
                </div>
            </div>

            <div className='buttonscontainer'>
                <div className='buttonsection'>
                    <button className='button' onClick={() => viewReadings(project.readings)}>Readings</button>
                </div>
            </div>

            <table className='table'>
                <thead>
                    <tr>
                        <th></th>
                        <th></th>
                        <th>Date</th>
                        <th>Name</th>
                        <th>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        project.readings
                        .sort((a, b) => b.ts - a.ts)
                        .map((reading, index) => {
                            return (
                                <tr key={'reading' + index}>
                                    <td><div className='table_button' onClick={() => editButton(reading)}>Edit</div></td>
                                    <td><div className='table_button' onClick={() => viewButton(reading)}>View</div></td>
                                    <td><div>{moment.unix(reading.ts).format('D/MMM/YYYY hh:mm:ss A')}</div></td>
                                    <td><div>{reading.name}</div></td>
                                    <td><div>{reading.amount}</div></td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    );
}

export default Readings;